/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Eyebrow_HealthInputs */

const en_us2_profile_editors_eyebrow_health = /** @type {(inputs: Profile_Editors_Eyebrow_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Health`)
};

const pt_br2_profile_editors_eyebrow_health = /** @type {(inputs: Profile_Editors_Eyebrow_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saúde`)
};

const es_419_profile_editors_eyebrow_health = /** @type {(inputs: Profile_Editors_Eyebrow_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salud`)
};

const pt_pt2_profile_editors_eyebrow_health = /** @type {(inputs: Profile_Editors_Eyebrow_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saúde`)
};

const fr_fr2_profile_editors_eyebrow_health = /** @type {(inputs: Profile_Editors_Eyebrow_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Santé`)
};

const de_de2_profile_editors_eyebrow_health = /** @type {(inputs: Profile_Editors_Eyebrow_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesundheit`)
};

const it_it2_profile_editors_eyebrow_health = /** @type {(inputs: Profile_Editors_Eyebrow_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salute`)
};

/**
* | output |
* | --- |
* | "Health" |
*
* @param {Profile_Editors_Eyebrow_HealthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_eyebrow_health = /** @type {((inputs?: Profile_Editors_Eyebrow_HealthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Eyebrow_HealthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_eyebrow_health(inputs)
	if (locale === "es-419") return es_419_profile_editors_eyebrow_health(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_eyebrow_health(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_eyebrow_health(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_eyebrow_health(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_eyebrow_health(inputs)
	return en_us2_profile_editors_eyebrow_health(inputs)
});
export { profile_editors_eyebrow_health as "profile-editors.eyebrow_health" }